import { Search } from 'lucide-react';

interface Props {
  valor: string;
  alCambiar: (valor: string) => void;
  marcador?: string;
  className?: string;
}

export function CampoDeBusqueda({ valor, alCambiar, marcador = 'Buscar…', className = '' }: Props) {
  return (
    <div className={`relative ${className}`}>
      <Search
        className="absolute left-3 top-1/2 size-[15px] -translate-y-1/2 text-armazon-400"
        aria-hidden
      />
      <input
        type="search"
        value={valor}
        onChange={(e) => alCambiar(e.target.value)}
        placeholder={marcador}
        aria-label={marcador}
        className="w-full rounded-lg border border-armazon-200 bg-white py-2 pl-9 pr-4 text-sm text-armazon-700 outline-none transition-colors placeholder:text-armazon-400 focus:border-marca-400 focus:ring-2 focus:ring-marca-500/20"
      />
    </div>
  );
}
